import PropTypes from 'prop-types';
import React from 'react';

export function LitterOverviewCardV1({ children, className, litter }) {
  return (
    <div className={className}>
      <p>
        <span className="sr-only">Litter</span>
        <span className="fw-medium">{litter.name}</span>
        <br />
        <span className="fw-light">
          {litter.status && (
            <>
              <span className="sr-only">with a litter status of</span>
              <span className="ttc dib">{litter.status}</span>
            </>
          )}
          {litter.birth_date && (
            <>
              <span className="sr-only">with a litter birth date of</span>
              <span> {litter.birth_date}</span>
            </>
          )}
          {(litter.status || litter.birth_date) &&
            litter.total_puppies_count > 0 &&
            ' • '}
          {litter.total_puppies_count > 0 && (
            <>
              <span className="sr-only">with</span>
              <span>
                {litter.reserved_puppies_count}/{litter.total_puppies_count}{' '}
                puppies reserved
              </span>
            </>
          )}
        </span>
      </p>
      {children}
    </div>
  );
}

LitterOverviewCardV1.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  litter: PropTypes.shape({
    birth_date: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    reserved_puppies_count: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    total_puppies_count: PropTypes.number.isRequired
  }).isRequired
};

LitterOverviewCardV1.defaultProps = {
  children: null,
  className: null
};
